import type {ReactElement} from 'react';
import React, {useEffect} from 'react';
import useDefaultPanelClose from '@Panels/hooks/useDefaultPanelClose';
import {Panel, PanelHeader} from '@Components/panel';
import {TableHorizontalSpacing} from '@Components/poster-editor/components/poster-editing-side-panel/components/table-horizontal-spacing';
import {ItemVerticalSpacingOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-vertical-spacing-option';
import {useUpdateEffect} from 'ahooks';
import {updateOptionsPanelHeight} from '@Components/poster-editor/library/poster-editor-library';
import {ContextualMenu} from '@Components/contextual-menu';
import styles from './poster-editor-layout-item-spacing-panel.module.scss';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';

interface PosterEditorLayoutItemSpacingPanelProps {
  panelId: string;
}

export default function PosterEditorLayoutItemSpacingPanel({...props}: PosterEditorLayoutItemSpacingPanelProps): ReactElement | null {
  const onClose = useDefaultPanelClose(props.panelId);
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;

  useUpdateEffect((): void => {
    onClose();
  }, [activeItemId]);

  useEffect((): void => {
    updateHeightInRedux();
  }, []);

  const updateHeightInRedux = (): void => {
    let height = '212px';
    if (activeItem?.isMenu()) {
      height = '140px';
    }
    updateOptionsPanelHeight(props.panelId, height);
  };

  if (!activeItem || (!activeItem.isTableItem() && !activeItem.isMenu())) {
    return null;
  }

  const getHeader = (): ReactElement => {
    return <PanelHeader onClose={onClose} title={window.i18next.t('pmwjs_spacing')} />;
  };

  const getLayoutSpacingOptions = (): ReactElement => {
    return (
      <>
        {activeItem.isMenu() ? null : <TableHorizontalSpacing />}
        <ItemVerticalSpacingOption />
      </>
    );
  };

  const getContent = (): ReactElement => {
    return (
      <ContextualMenu id="layout-item-mobile-spacing-panel" hasMobileModalPadding hasMobileMorphingProperties>
        <div className={`flex-v-row ${styles.items}`}>{getLayoutSpacingOptions()}</div>
      </ContextualMenu>
    );
  };

  return <Panel panelHeader={getHeader()} panelContent={getContent()} />;
}
